export const UserMenuItems: any[] = [
  {
    title: "profile",
    icon: "user-circle",
    path: "/profile",
  },
  {
    title: "overview",
    icon: "th-large",
    path: "/event/overview",
  },
  {
    title: "contribute_overview",
    icon: "user-friends",
    path: "/contribute/overview",
  },
  {
    title: "stats",
    icon: "chart-pie",
    path: "/stats",
  },
];
